<template>
  <div
    class="campaign-stats-overall-chart-legend"
    :class="{ 'campaign-stats-overall-chart-legend--inactive': !isActive }"
    v-on="$listeners"
  >
    <div
      :style="circleStyle"
      class="campaign-stats-overall-chart-legend__circle"
    />
    <span class="campaign-stats-overall-chart-legend__value">
      {{ value }}
    </span>
    <span class="campaign-stats-overall-chart-legend__title">
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'CampaignStatsOverallChartLegend',
  props: {
    color: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      required: true,
    },
    isActive: Boolean,
  },
  computed: {
    circleStyle() {
      return {
        background: this.color,
      };
    },
  },
};
</script>

<style lang="scss">
.campaign-stats-overall-chart-legend {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  transition-duration: 0.2s;
  color: #9da0af;

  &--inactive {
    opacity: 0.2;
  }

  &__value {
    font-weight: bold;
    font-size: rem-calc(20px);
    color: #20222a;
  }

  &__title {
    padding: 0 $global-padding;
  }

  &__circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: $global-margin;

    @include rtl() {
      margin-right: 0;
      margin-left: $global-margin;
    }
  }
}
</style>
